<template>
    <p class="mb-3 text-left text-lg text-white">
        <slot />
    </p>
</template>
